import { render } from "./AdminDrawer.vue?vue&type=template&id=70c2e546&scoped=true"
import script from "./AdminDrawer.vue?vue&type=script&lang=js"
export * from "./AdminDrawer.vue?vue&type=script&lang=js"

import "./AdminDrawer.vue?vue&type=style&index=0&id=70c2e546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c2e546"]])

export default __exports__